import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductListAPI } from '../model/product-list';
import { ServicePointSetupAPI } from '@auth-suite-services/mbe-service';
import { ConfigService } from './config.service';
// See C004 - 2026-01-23 - HE
// import { BasicResponse } from '@auth-suite-services/services';
import { ProductLinkAPI } from '../model/product-link';

@Injectable({
  providedIn: 'root',
})
export class ProductLinkService {
  private URL;
  private URLTwo;
  private AmassENSURL;

  headers: HttpHeaders;

  constructor(
    @Inject(ConfigService) private config: any,
    private httpClient: HttpClient,
  ) {
    this.AmassENSURL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find(
        (restUrl: { api: string }) => restUrl.api === 'SDSETUP',
      ).url;
    this.URLTwo =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'SDSETUP')
        .url;

    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find(
        (restUrl: { api: string }) => restUrl.api === 'PADM',
      ).url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  // getProductLinks(id: number) {
  //   const headers = this.headers;
  //   return this.httpClient.get<any>(
  //     `${this.URLTwo}/pln/getallproductlink/${id}`,
  //     { headers }
  //   );
  // }

  getProductLinks(id: number): Observable<ProductLinkAPI> {
    const headers = this.headers;
    return this.httpClient.get<any>(
      `${this.URLTwo}/pln/getallproductlink/${id}`,
      { headers },
    );
  }

  getProductLinkCheck(id: number): Observable<ProductLinkAPI> {
    const headers = this.headers;
    return this.httpClient.get<any>(
      `${this.URLTwo}/pln/getallproductlinkcheck/${id}`,
      { headers },
    );
  }

  updateLink(id: number, prodIdList: any[], total: number) {
    console.log('update product link');
    console.log(id, prodIdList);
    const jsonObject = {
      prodIdList: prodIdList,
    };
    const headers = this.headers;
    // See C004 - 2026-01-23 - HE
    // return this.httpClient.post<BasicResponse>(
    //   `${this.URLTwo}/pln/createproductlink/${id}/${total}`,
    //   jsonObject,
    //   { headers },
    // );
    // API returns {errorNo: number} format, not BasicResponse
    return this.httpClient.post<{errorNo: number}>(
      `${this.URLTwo}/pln/createproductlink/${id}/${total}`,
      jsonObject,
      { headers },
    );
  }

  getAllSPS(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    gidFrom: number,
    gidTo: number,
    creationDate: string,
    servicePointName: string,
    gidProduct: number,
  ): Observable<ServicePointSetupAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    return this.httpClient.get<ServicePointSetupAPI>(
      `${this.URL}/sps/allspsfilter/${pageIndex}/${pageSize}/${
        sortActive ? sortActive : 'id'
      }/${sort ? sort : 'asc'}/${gidFrom ? gidFrom : 0}/${
        gidTo ? gidTo : 0
      }/${creationDate ? creationDate : '0'}/${
        servicePointName ? servicePointName : '0'
      }/${gidProduct}`,
      { headers },
    );
  }

  getAllProductList(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
  ): Observable<ProductListAPI> {
    const headers = this.headers;
    const jsonObject = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortActive: sortActive,
      sort: sort,
    };

    return this.httpClient.post<ProductListAPI>(
      `${this.URL}/pli/allpli`,
      jsonObject,
      { headers },
    );
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C004: Updated updateLink() method return type from BasicResponse to {errorNo: number} to match actual API response format. Previous behavior: Method returned Observable<BasicResponse> but API actually returns {"errorNo":0} format where errorNo: 0 indicates success. This mismatch caused type confusion and incorrect response handling in components. New behavior: Changed return type to Observable<{errorNo: number}> to accurately reflect API response structure. Reason: API endpoint /pln/createproductlink/{id}/{total} returns {"errorNo":0} on success, not BasicResponse format. Context: Part of fix for product link update success message display issue. Impact: Improved type safety, accurate response handling, no breaking changes to method signature (only type annotation changed). - 2026-01-23 - HE
